"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
var _ResultCode = _interopRequireDefault(require("./ResultCode"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/**
 * eXtend Media Paywall Service API
 * Media Wall API Specification
 *
 * The version of the OpenAPI document: v1
 * Contact: t.ioannidis@extend.gr
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

/**
 * The SimpleErrorResult model module.
 * @module model/SimpleErrorResult
 * @version 1.1.3-alpha.1
 */
class SimpleErrorResult {
  /**
   * Constructs a new <code>SimpleErrorResult</code>.
   * @alias module:model/SimpleErrorResult
   */
  constructor() {
    SimpleErrorResult.initialize(this);
  }

  /**
   * Initializes the fields of this object.
   * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
   * Only for internal use.
   */
  static initialize(obj) {}

  /**
   * Constructs a <code>SimpleErrorResult</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/SimpleErrorResult} obj Optional instance to populate.
   * @return {module:model/SimpleErrorResult} The populated <code>SimpleErrorResult</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new SimpleErrorResult();
      if (data.hasOwnProperty('message')) {
        obj['message'] = _ApiClient.default.convertToType(data['message'], 'String');
      }
      if (data.hasOwnProperty('error')) {
        obj['error'] = _ApiClient.default.convertToType(data['error'], Object);
      }
      if (data.hasOwnProperty('code')) {
        obj['code'] = _ResultCode.default.constructFromObject(data['code']);
      }
      if (data.hasOwnProperty('success')) {
        obj['success'] = _ApiClient.default.convertToType(data['success'], 'Boolean');
      }
    }
    return obj;
  }

  /**
   * Validates the JSON data with respect to <code>SimpleErrorResult</code>.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @return {boolean} to indicate whether the JSON data is valid with respect to <code>SimpleErrorResult</code>.
   */
  static validateJSON(data) {
    // ensure the json data is a string
    if (data['message'] && !(typeof data['message'] === 'string' || data['message'] instanceof String)) {
      throw new Error("Expected the field `message` to be a primitive type in the JSON string but got " + data['message']);
    }
    return true;
  }
}

/**
 * An error message
 * @member {String} message
 */
SimpleErrorResult.prototype['message'] = undefined;

/**
 * @member {Object} error
 */
SimpleErrorResult.prototype['error'] = undefined;

/**
 * @member {module:model/ResultCode} code
 */
SimpleErrorResult.prototype['code'] = undefined;

/**
 * @member {Boolean} success
 */
SimpleErrorResult.prototype['success'] = undefined;
var _default = SimpleErrorResult;
exports.default = _default;